module.exports = __webpack_public_path__ + "img/COMBO TWIRL LIME.49e58c0.svg";